import React, { useEffect } from 'react'
import Nav from '../components/Nav'
import { useFormik } from 'formik';
import Loader from "../components/Loading.svg"
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PositionedSnackbar from '../components/snackbar';
import axios from 'axios';
import { UseHrApp } from '../utils/context';


export default function SignInAdmin() {
    
  const [loading , setloading ]= useState(false)
  const [show, setshow] = useState(false);
  const [text, settext] = useState("");
  const [severity,setseverity]= useState('error')
  const navigate = useNavigate()
const {getStats} =UseHrApp();

  const formic = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: (values) => {
      const errors = {};
      // Validation code...
      return errors;
    },
    onSubmit: async (values) => {
      setloading(true);
      try {
        const response = await axios({
          url:'https://hr-app-api.onrender.com/api/admin/login',
          method:'POST',
          data:{
            email: values.email,
            password: values.password,
       
      
          }
        })
       if(response?.data?.status){
       
      
        localStorage.setItem("token",response?.data?.token )
        navigate('/admin/mainDash/main')
      }
      } 
      catch (error) {
        settext("Failed to log in. Please try again.");
        setshow(true);
        setseverity('error')
      }
      setloading(false);
    },
  });

  useEffect(()=>{
    getStats();
  },[])
  return (
    <div className=' w-full h-screen '>
        <Nav/>
        <div className=" w-full h-[90vh] flex flex-col justify-center items-center px-[2em]">
        <div className=" w-full min-h-[40%] flex flex-col justify-center gap-3 md:px-[11em] lg:px-[20em] xl:px-[27em]">
          <p className=" text-2xl font-[Archivo] font-medium">
            Enter your credentials
          </p>
          <form
            className=" flex flex-col gap-5"
            onSubmit={(e) => {
              e.preventDefault();
              formic.handleSubmit()

      
            }}
          >
            <div>
              <Input
                label={"Email"}
                placeholder={"user@example.com"}
                name={"email"}
                type="email"
                onChange={formic.handleChange}
                value={formic.values.email}
                error={formic.errors.email}
              />
              {formic.errors.email && (
                <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                  *{formic.errors.email}
                </p>
              )}
            </div>
            <div>
              <Input
                label={"Password"}
                placeholder={"••••••••"}
                name={"password"}
                type="password"
                onChange={formic.handleChange}
                value={formic.values.password}
                error={formic.errors.password}
              />
              {formic.errors.password && (
                <p className="text-[#EF0107] font-[300] text-[0.8rem]">
                  *{formic.errors.password}
                </p>
              )}
            </div>

            <button
              className=" w-max py-[.8em] px-[1em] bg-[#1E2029] rounded-[.8em]"
              type="submit"
            >
              <p className=" text-white">
                {loading ? (
                  <img src={Loader} className="h-[2rem]" key={loading} />
                ) : (
                  "Login"
                )}
              </p>
            </button>
          </form>

          <PositionedSnackbar value={show} setshow={setshow} text={text} severity={severity}/>
        </div>
      </div>
    </div>
  )
}



const Input = ({ label, type, name, onChange, placeholder, value, error }) => {
    return (
      <div className="flex flex-col gap-3">
        <label className="text-[0.9rem] font-[400] text-black/50">{label}</label>
        <input
          formNoValidate={false}
          type={type}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          className={`focus:border-none  border-[2px] ${
            !error
              ? "focus:outline-[#4FFFB0] outline-black/25"
              : "focus:outline-[#EF0107] border-[#EF0107]"
          }  focus:outline-[2px]  px-4 py-2 rounded duration-700 text-black/80 bg-slate-50`}
        />
      </div>
    );
  };